import { render, staticRenderFns } from "./LegalContent.vue?vue&type=template&id=edc5df22&scoped=true&"
import script from "./LegalContent.vue?vue&type=script&lang=js&"
export * from "./LegalContent.vue?vue&type=script&lang=js&"
import style0 from "./LegalContent.vue?vue&type=style&index=0&id=edc5df22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc5df22",
  null
  
)

export default component.exports